export function isNeedToShowAddressWidgetItemIcons() {
  return false
}
